export default {
  name: 'easyBid',
  path: '/easyBid',
  component: () => import('@/views/easyBid/index.vue'),
  children: [
    {
      name: 'index', // 新增标书
      path: '',
      meta: {
        auth: true
      },
      component: () => import('@/views/easyBid/edit/index'),
      children: [
        {
          name: 'edit', // 新增标书
          path: '',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/edit/edit')
        },
        {
          name: 'bid-name', // 标书名称编辑
          path: 'bidName',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/edit/bidName')
        },
        {
          name: 'invite', // 邀标
          path: 'invite',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/edit/invite')
        },
        {
          name: 'upload', // 邀标
          path: 'upload',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/edit/upload-picture')
        }
      ]
    },
    {
      name: 'easyBid-project', // 选项目
      path: 'project',
      component: () => import('@/views/easyBid/project/index'),
      children: [
        {
          name: 'project-manage', // 项目管理
          path: '',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/project/manage')
        },
        {
          name: 'project-add', // 添加项目
          path: 'add',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/project/add/index'),
          children: [
            {
              name: 'project-add-index', // 添加项目主页
              path: '',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/add')
            },
            {
              name: 'project-add-projName', // 首页
              path: 'projName',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/projName')
            },
            {
              name: 'project-add-contName', // 首页
              path: 'contName',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/contName')
            },
            {
              name: 'project-add-mobile', // 首页
              path: 'mobile',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/mobile')
            },
            {
              name: 'project-add-delAddress', // 首页
              path: 'delAddress',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/delAddress')
            },
            {
              name: 'project-add-projIntro', // 首页
              path: 'projIntro',
              meta: {
                auth: true
              },
              component: () => import('@/views/easyBid/project/add/projIntro')
            }
          ]
        }
      ]
    },
    {
      name: 'product', // 选招标商品
      path: 'product',
      component: () => import('@/views/easyBid/product/index'),
      children: [
        {
          name: 'choose',
          path: '',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/product/choose')
        },
        {
          name: 'subName',
          path: 'subName',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/product/subName')
        },
        {
          name: 'remark',
          path: 'remark',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/product/remark')
        },
        {
          name: 'unit',
          path: 'unit',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/product/unit')
        }
      ]
    },
    { // 投标
      name: 'bid',
      path: 'bid',
      component: () => import('@/views/easyBid/bid/index'),
      children: [
        {
          name: 'detail',
          path: '',
          component: () => import('@/views/easyBid/bid/detail')
        },
        {
          name: 'check-image',
          path: 'check',
          component: () => import('@/views/easyBid/bid/check-image.vue')
        },
        {
          name: 'product-detail',
          path: 'product',
          component: () => import('@/views/easyBid/bid/product')
        },
        {
          name: 'edit',
          path: 'edit',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/bid/edit')
        },
        {
          name: 'price',
          path: 'price',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/bid/price')
        },
        {
          name: 'tenderExplain',
          path: 'tenderExplain',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/bid/tenderExplain')
        },
        {
          name: 'success',
          path: 'success',
          meta: {
            auth: true
          },
          component: () => import('@/views/easyBid/bid/success')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/easyBid.js